import { render, staticRenderFns } from "./MarketPlace.vue?vue&type=template&id=3c29797c&scoped=true"
import script from "./MarketPlace.vue?vue&type=script&lang=js"
export * from "./MarketPlace.vue?vue&type=script&lang=js"
import style0 from "./MarketPlace.vue?vue&type=style&index=0&id=3c29797c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c29797c",
  null
  
)

export default component.exports